const BASE_36 = 36;

/** Genera una stringa base36 casuale della lunghezza richiesta. */
export function randomBase36(length: number): string {
  let result = "";
  for (let index = 0; index < length; index++) {
    result += Math.floor(Math.random() * BASE_36).toString(BASE_36);
  }
  return result;
}

/** Genera un ID compatto composto da timestamp base36 e suffisso casuale. */
export function timestampBase36(randomLength = 5): string {
  return `${Date.now().toString(BASE_36)}-${randomBase36(randomLength)}`;
}
